'use client'

import type React from 'react'
import { use } from 'react'
import { useModals, useSearchParams } from '@/lib/hooks'

import {
  Button,
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui'
import { CheckoutViewPayments } from '@/components/molecules'
import { RefContext, type Refs } from '@/components/providers/ref-provider'

interface ViewCartPaymentsModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const ViewCartPaymentsModal = ({ open }: ViewCartPaymentsModalProps) => {
  const { amountInputRef } = use(RefContext) as Refs
  const { closeModal } = useModals()
  const { cartId } = useSearchParams()

  return (
    <Drawer
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          amountInputRef?.current?.focus()
          closeModal('VIEW_CART_PAYMENTS')
        }
      }}
    >
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>Payments</DrawerTitle>
          <DrawerDescription>
            Payments processed for Cart Id{' '}
            <span className="font-medium text-gray-950">{cartId}</span>
          </DrawerDescription>
        </DrawerHeader>

        {cartId && (
          <CheckoutViewPayments className="w-full min-w-[320px] md:min-w-[400px] lg:w-[25svw]" />
        )}

        <DrawerFooter>
          <DrawerClose asChild>
            <Button variant="secondary" className="w-full">
              Close
            </Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  )
}
